import { Thunk } from 'ha/myredux/types';
import { parse } from 'set-cookie-parser';
import { AuthLogicActions } from './actions';

export const fetchUser: () => Thunk = () => (dispatch, _, services) =>
  Promise.all([
    services.apiV2.getUser('me'),
    services.apiV2.getUserInformation('me', {
      expand:
        'advertiserBookingsCount,savedPaymentMethodsCount,listingsCount,subscriptionFeatures',
    }),
  ])
    .then(([{ data: user, headers }, { data: userInformation }]) => {
      try {
        if (!process.browser) {
          const setCookies = parse(headers?.get('set-cookie') as string);
          setCookies.forEach(cookie => {
            services.cookie.setCookie(cookie.name, cookie.value, {
              // The `cookies` package used as the client for services.cookie expects maxAge in milliseconds!
              // The spec says max-age is in seconds, so we convert it here.
              maxAge: cookie.maxAge ? cookie.maxAge * 1000 : undefined,
              domain: cookie.domain,
              path: cookie.path,
              expires: cookie.expires,
              httpOnly: cookie.httpOnly,
            });
          });
        }
      } catch (error) {
        // An error here is not critical, so we just log it to the console.
        // eslint-disable-next-line no-console
        console.error(error);
      }

      dispatch(
        AuthLogicActions.initUser({
          user,
          userInformation,
        }),
      );
    })
    .catch(() => {
      dispatch(AuthLogicActions.authDone());
    });
